const API_BASE_URL = process.env.REACT_APP_API_URL;

// Helper function to ensure trailing slash
const ensureTrailingSlash = (url) => (url?.endsWith('/') ? url : `${url}/`);

const base = ensureTrailingSlash(API_BASE_URL);

export const ApiEndPoints = {

  // Login
  postLoginUrl: () => `${base}login`,
  postLoginForgotPassword: () => `${base}forgotpassword`,
  poastLoginForgotPasswordMail: () => `${base}mailverification`,

  // Dashboard
  postDashboardTableData: () => `${base}dashboarddate`,

  // Escalations
  postEscalationsFollowUp: () => `${base}followup`,
  postEscalationsTableData: () => `${base}escalationdate`,

  // Admin
  getAdminRules: () => `${base}adminrules`,
  getAdminOpenCalls: () => `${base}activeagent`,
  
  postAdminAddUsers: () => `${base}addusers`,
  postAdminPatientCalls: () => `${base}callinitiate`,
  postAdminRulesUpdate: () => `${base}updateadminrules`,
  postAdminCompletedCalls: () => `${base}completedagents`,
  postAdminSelectedCompletedCall: () => `${base}agentlogs`,
};

export default ApiEndPoints; 